import { Platform, StyleSheet } from 'react-native'
import type { Theme } from '../../../theme/getTheme'

export function getAccountAdminNavDrawerStyles(theme: Theme, topInset: number) {
  return StyleSheet.create({
    drawerWrapper: {
      flex: 1,
      width: '100%' as never,
      height: '100%' as never,
      alignItems: 'flex-start',
      ...(Platform.OS === 'web' && {
        minHeight: '100vh' as never,
      }),
    },
    drawerPanel: {
      flex: 1,
      backgroundColor: theme.background.card,
      ...(Platform.OS === 'web'
        ? {
            boxShadow: '4px 0 16px rgba(0,0,0,0.12)',
            height: '100%' as never,
            minHeight: '100%' as never,
            zIndex: 1002,
          }
        : {
            shadowColor: theme.shadow,
            shadowOffset: { width: 4, height: 0 },
            shadowOpacity: 0.18,
            shadowRadius: 10,
            elevation: 12,
          }),
      overflow: 'hidden',
    },
    drawerInner: {
      flex: 1,
      paddingTop: topInset + 8,
      paddingBottom: 16,
    },
    drawerHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',
      paddingHorizontal: theme.spacing.md,
      paddingBottom: theme.spacing.md,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.gray[200],
    },
    closePressable: {
      padding: theme.spacing.sm,
      borderRadius: theme.borderRadius.sm,
    },
    closePressed: {
      opacity: 0.75,
    },
    closeHover: {
      opacity: 0.88,
    },
    navScroll: {
      flexGrow: 1,
    },
    navScrollContent: {
      paddingVertical: theme.spacing.sm,
      paddingHorizontal: theme.spacing.xs,
      paddingBottom: theme.spacing.xl,
    },
    navRowSubLevel: {
      marginLeft: theme.spacing.lg,
      marginRight: theme.spacing.xs,
    },
    navRowOrgParentActive: {
      backgroundColor: theme.background.primary,
      borderColor: theme.gray[300],
    },
    navRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing.md,
      paddingVertical: theme.spacing.md,
      paddingHorizontal: theme.spacing.md,
      borderRadius: theme.borderRadius.md,
      borderWidth: 1,
      borderColor: 'transparent',
      marginHorizontal: theme.spacing.xs,
      marginVertical: 2,
    },
    navRowActive: {
      backgroundColor: theme.background.primary,
      borderColor: theme.gray[300],
    },
    navRowPressed: {
      opacity: 0.88,
    },
    navRowHover: {
      opacity: 0.92,
    },
    navLabel: {
      fontSize: 16,
      fontWeight: '700',
      color: theme.gray[700],
      flex: 1,
    },
    navLabelActive: {
      color: theme.primaryLight,
    },
    navRowLocked: {
      opacity: 0.6,
    },
    navLabelLocked: {
      color: theme.gray[500],
    },
  })
}
